<template>
  <div class="taskdetails">
    <el-header style="height:40px;">
      <el-page-header @back="goBack" :content="info.type==1?'作业详情':'考试详情'">
      </el-page-header>
    </el-header>
    <div class="contents">
      <div class="twodiv">
        <div class="leftdiv">
          <div>
            <div class="tit">题目描述:
              
            </div>
            <div class="condiv">
              {{info.description}}
            </div>
            <div class="condiv">
              <img v-if="info.detail" :src="GLOBAL.BASE_URL+info.detail" class="imgde">
            </div>
          </div>
          <div v-if="info.cate.id==3" class="sm">
            <div class="tit">素描图片:</div>
            <div class="condiv">
              <el-upload class="upload-demo" :action="uploadUrl" :limit="9" :on-success="handleInfoSuccess" :on-remove="handleInfoRemove" list-type="picture-card">
                <i class="el-icon-plus"></i>
              </el-upload>
            </div>
          </div>
          <div v-if="info.cate.id==3" class="sm">
            <div class="tit">相关理解:</div>
            <div class="condiv">
              <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="textarea">
              </el-input>
            </div>
          </div>
        </div>
      </div>
<el-button type="primary" size="mini" class="btn1" @click="submitbtn(info)" style="margin-top:10px">提交</el-button>
    </div>
    <button></button>
  </div>
</template>

<script>
export default {
  props: {

  },
  data() {
    return {
      info: {},
      uploadUrl: this.GLOBAL.BASE_URL + '/api/common/upload_file',
      ImgList: [],
      textarea:''
    };
  },
  computed: {

  },
  created() {
    this.info = JSON.parse(this.$route.query.item);

    console.log(this.info)

  },
  methods: {
    //提交
    submitbtn(item) {
      //作业
      if (item.type == 1) {
        var nowdate = new Date().getTime()
        var enddate = new Date(item.end_time).getTime();
        if (nowdate > enddate) {
          this.$message({
            message: '不在做作业时间范围內！',
            type: 'warning'
          });
        } else {
          //卡环
          if (item.cate.id == 2) {
            // var tooth = JSON.parse(item.tooth_num);
            // var strtooth = ''
            // for (var i = 0; i < tooth.length; i++) {
            //   strtooth = strtooth + '_' + tooth[i]
            // }
            if (item.cate.url) {
             
                window.location.href =
                  item.cate.url +
                  "?data="+ this.$store.getters.getUserInfo.id+'+'+this.$store.getters.getUserInfo.realname +'+Job+'+item.tooth_num+'+'+ item.id 
                // "+" +
                // baseurl + "+" + this.code + "+" + this.$route.params.detailId;


              
            } else this.$message("暂未开放");

          } else if (item.cate.id == 3) {
            //素描
            this.smbtn(item);
          } else {
                if (item.cate.url) {
            //非卡环
            window.location.href =
              item.cate.url +
               "?data="+ this.$store.getters.getUserInfo.id+'+'+this.$store.getters.getUserInfo.realname+'+Job+'+ item.id }else{
                this.$message("暂未开放");  
              }
          }
        }
      } else {
        //考试
        var nowdate = new Date().getTime()
        var enddate = new Date(item.end_time).getTime();
        var startdate = new Date(item.start_time).getTime();
        if ((nowdate > enddate) || (startdate > nowdate)) {
          // this.tabledata[i].statustime = true;
          this.$message({
            message: '不在考试时间范围內！',
            type: 'warning'
          });
        } else {
          // this.tabledata[i].statustime = false;


          console.log("提交")
          //卡环
          if (item.cate.id == 2) {
            //   var tooth = JSON.parse(item.tooth_num);
            //   var strtooth = ''
            //   for (var i = 0; i < tooth.length; i++) {
            //     strtooth = strtooth + '_' + tooth[i]
            //   }
            if (item.cate.url) {
              if (this.$cookies.get("token")) {
                window.location.href =
                  item.cate.url +
                   "?data="+ this.$store.getters.getUserInfo.id+'+'+this.$store.getters.getUserInfo.realname+'+Exam+'+item.tooth_num+'+'+ item.id 
              } else this.$router.push({ name: "Login" });
            } else this.$message("暂未开放");

          } else if (item.cate.id == 3) {
            //素描
            this.smbtn(item);
          } else {
            //非卡环
            window.location.href =
              item.cate.url +
               "?data="+ this.$store.getters.getUserInfo.id+'+'+this.$store.getters.getUserInfo.realname+ '+Exam+' + item.id;

          }
        }


      }
    },
    //素描提交
    smbtn(item) {
      var params = {
        task_id: item.id,
        student_answer: this.ImgList,
        student_des:this.textarea
      }
      this.$http.insert_student_record(params)
        .then(res => {
          if (res.code != 0) {
            this.$message({
              message: '提交成功',
              type: 'success'
            });

          } else {
            this.$message.error(res.message)
          }

        })
    },
    goBack() {
      this.$router.back()
    },
    // 产品详情 图片上传成功
    handleInfoSuccess(res, file, fileList) {
      //this.ImgList.push(this.GLOBAL.BASE_URL + '/' + res.data)
      this.ImgList.push(res.data)
      console.log(this.ImgList)
    },
    // 产品详情 图片删除成功
    handleInfoRemove(file, fileList) {
      var arr = this.ImgList;
      for (var i = 0; i < arr.length; i++) {
        if (arr[i] == file.url) {
          this.ImgList.splice(i, 1);

          break;
        }
      }

    },
  },
};
</script>

<style  lang="less">
.taskdetails {
    .sm{
        margin-top: 10px;
    }
  .btn {
    margin-left: 20px;
  }
  .contents {
    padding: 20px;
     background: #f9f9f9;
     overflow: hidden;
    // padding-top: 0px;
  }
  .firstdiv {
    overflow: hidden;
    div {
      width: 25%;
    }
    .taskname {
      float: left;
      color: #5193f7;
      font-size: 16px;
      font-weight: bold;
    }
    .teachername {
      color: #303133;
      font-size: 16px;
      float: left;
    }
  }
  .twodiv {
    overflow: hidden;
    .leftdiv {
      .tit {
        margin-bottom: 10px;
        font-weight: bold;
      }
      // width: 33.33%;
      width: 100%;
      float: left;
      .condiv {
        padding-right: 10px;
        overflow: hidden;
      }
      .imgde {
        width: 700px;
        margin-top: 10px;
      }
      .imglist {
        height: 200px;
        float: left;
        margin-left: 10px;
        margin-bottom: 10px;
      }
    }
    .leftdiv1 {
      width: 50%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/assessment/taskdetails.vue